import { EDHRECIconsType } from '@/components/Icon/Icon'

export const desktopWidth = 1024

export type Mode = {
  icon?: EDHRECIconsType
  key: string
  skipFetch?: boolean
  value: string
}

export const defaultGroupedBy = 'default'

export const defaultSortedBy = 'percent'

export const groupByModes: Mode[] = [
  { icon: 'tableList', key: 'default', skipFetch: true, value: 'Category' },
  { icon: 'tag', key: 'type', value: 'Type' },
  { icon: 'arrowDown19', key: 'mana', value: 'Mana Value' },
  { icon: 'dollarSign', key: 'price', value: 'Price' },
  { icon: 'star', key: 'rarity', value: 'Rarity' },
  { icon: 'calendar', key: 'date', value: 'Release date' },
  { icon: 'tableCellsLarge', key: 'ungrouped', skipFetch: true, value: 'Ungrouped' },
]

export const sortByModes: Mode[] = [
  { icon: 'percent', key: 'percent', skipFetch: true, value: 'Deck Percent' },
  { icon: 'hashtag', key: 'count', skipFetch: true, value: 'Deck Count' },
  { icon: 'wandMagicSparkles', key: 'synergy', skipFetch: true, value: 'Synergy' },
  { icon: 'font', key: 'name', skipFetch: true, value: 'Name' },
  { icon: 'arrowDown19', key: 'mana', value: 'Mana Value' },
  { icon: 'dollarSign', key: 'price', value: 'Price' },
  { key: 'salt', value: 'Salt' },
]

export const recaptchaKey = '6Lce4KcUAAAAABGKupP_l1JmBkkDNj39TOOU3ulX'

export const TIMESPANS = [undefined, 'week', 'month', 'year']

export const COLORS = [
  'w',
  'u',
  'b',
  'r',
  'g',
  'wu',
  'ub',
  'br',
  'rg',
  'gw',
  'wb',
  'ur',
  'bg',
  'rw',
  'gu',
  'wub',
  'ubr',
  'brg',
  'rgw',
  'gwu',
  'wbg',
  'urw',
  'bgu',
  'rwb',
  'gur',
  'wubr',
  'ubrg',
  'brgw',
  'rgwu',
  'gwub',
  'wubrg',
  'colorless',
]
